import { IpisFormElement } from "@eljouren/domain";
import { useFormEditor } from "../../../../../../hooks/checklist-hooks";
import ChecklistYesNoInputBuilder from "./ChecklistYesNoInputBuilder";

interface Props {
  className?: string;
  closeForm: () => void;
  question: IpisFormElement.YesNoType;
}

const ChecklistYesNoInputEditor = (props: Props) => {
  const ctx = useFormEditor();

  return (
    <ChecklistYesNoInputBuilder
      closeForm={props.closeForm}
      onSubmit={(values) => {
        ctx.controls.editElement({ id: props.question.id, newValues: values });
        props.closeForm();
      }}
      defaultValues={props.question}
    />
  );
};

export default ChecklistYesNoInputEditor;
